<script>
  export let exercise
</script>

<li class="list-group-item">
  <div class="d-flex align-items-center">
    {#if exercise.execution_type == 'count_based'}
      {exercise.amount}×
    {:else}
      {exercise.amount}s
    {/if}
    {exercise.exercise.name}
  </div>
</li>
